// extracted by mini-css-extract-plugin
export var gif = "_mi-0";